"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showTypeEnum = exports.placeholderPositionEnum = exports.pageTypeEnum = exports.filterGoodsEnum = void 0;
// 页面类型
var pageTypeEnum = exports.pageTypeEnum = [{
  label: '首页',
  value: 1
}, {
  label: '专题页',
  value: 2
}, {
  label: '共享页',
  value: 3
}, {
  label: '权益卡包兑换页',
  value: 4
}, {
  label: '游客首页',
  value: 5
}];
// 文本位置
var placeholderPositionEnum = exports.placeholderPositionEnum = [{
  label: '居左',
  value: 1
}, {
  label: '居中',
  value: 2
}];

// 展示样式
var showTypeEnum = exports.showTypeEnum = [{
  label: '一行一图',
  value: 1
}, {
  label: '一行两图',
  value: 2
}, {
  label: '一行三图',
  value: 3
}, {
  label: '一行四图',
  value: 4
}, {
  label: '一大两小',
  value: 5
}, {
  label: '田字格',
  value: 6
}];

// 页面状态
var filterGoodsEnum = exports.filterGoodsEnum = [{
  label: '指定分类',
  value: 1
}, {
  label: '指定标签',
  value: 2
}, {
  label: '指定SKU',
  value: 3
}];